export default __webpack_public_path__ + "static/media/Huawei Nexus 6p.e251cdb3.png";